import React from "react";

import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkGiantWild {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkGiantWild: IframeworkGiantWild = {

    data: {
        "COMPONENTS": [
            {
                "id": "GiantWildContainer",
                "name": "GiantWildContainer",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": true,
                "filterTypes": [],
                child: [

                    {
                        "name": "Orb_Fx_loop",
                        "type": "Animation",
                        "width": 150,
                        "height": 150,
                        "image": "Orb_Fx_loop",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": true,
                        "loop": true,
                        //  "layout": false,
                        //  "uimode": "desktop",
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1815,
                        "y": 800,
                        "animations": {
                            "anim": "Orb_Fx_loop",
                        },
                    },

                    //   {
                    //       "name": "Orb_Fx_loop_mobile",
                    //       "type": "Animation",
                    //       "width": 150,
                    //       "height": 150,
                    //       "image": "Orb_Fx_loop",
                    //       "parentLayer": "specialAnimationLayer",
                    //       "animationSpeed": 0.2,
                    //       "layout": true,
                    //       "uimode": "mobile",
                    //       "playing": true,
                    //       "loop": true,
                    //       "visible": false,
                    //       // "scae"
                    //       "anchor": [0.5, 0.5],
                    //       "x": 1815,
                    //       "y": 800,
                    //       "animations": {
                    //           "anim": "Orb_Fx_loop",
                    //       },
                    //   },

                    {
                        "name": "skull_glow",
                        "image": "scull_glow",
                        "type": "Image",
                        "visible": false,
                        "width": 180,
                        "height": 180,
                        "anchor": [0.5, 0.5],
                        "x": 1522,
                        "y": 470,
                    },
                    {
                        "id": "wild_1X2_fx",
                        "name": "wild_1X2_fx",
                        "type": "Spine",
                        "x": 1684,
                        "y": 987,
                        "width": 311.08,
                        "height": 660.94,
                        "layout": false,
                        //  "scale"
                        "visible": false,
                        "anchor": [0.5, 0.5],
                        "spinedata": {
                            "spinename": "symbols_blast_anim",
                            "animationname": "wild_1X2_fx",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "wild_1X3_fx",
                        "name": "wild_1X3_fx",
                        "type": "Spine",
                        "x": 1656,
                        "y": 989,
                        "width": 311.08,
                        "height": 660.94,
                        "layout": false,
                        "visible": false,
                        "anchor": [0.5, 0.5],
                        "spinedata": {
                            "spinename": "symbols_blast_anim",
                            "animationname": "wild_1X3 fx",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },

                    {
                        "id": "glow_yellow_blast",
                        "name": "glow_yellow_blast",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_yellow",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },

                ]
            },

        ]
    }

};

export const GiantWildConfigurationContext = React.createContext(
    {}
);